// import edit from './Edit'
// import readonly from './ReadOnly'
// import signature from './Signature'
// import summary from './Summary'
import React from "react";

const edit = React.lazy(() => import("./Edit"));
const readonly = React.lazy(() => import("./ReadOnly"));
const signature = React.lazy(() => import("./Signature"));
const summary = React.lazy(() => import("./Summary"));

const modes = {
  edit,
  readonly,
  signature,
  summary,
  end: summary,
};
export default modes;
